import React from "react";
import NavBar from "../components/navbar";
import Footer from "../components/footer";

function About() {
  return (
    <div>
      <NavBar about="active" />
      <div className="container">
        <h1 className="text-center text-white mb-4">About Us</h1>
        <h3 className="text-white">
          Discover, Rate, and Review Your Next Favorite Movie!
        </h3>
        <p className="text-white mb-4">
          Welcome to ReelReviews—your ultimate destination for finding, rating, and
          reviewing movies online! We’re passionate about films and dedicated to
          building a community where real cinema lovers can share honest opinions.
        </p>
        <h3 className="text-white">Our Mission</h3>
        <p className="text-white mb-4">
          At ReelReviews, our mission is simple: to make discovering what to watch
          next easy, authentic, and driven by real voices. Whether you’re a 
          hardcore film critic or just looking for a casual weekend watch, we rely 
          on the community to guide you away from the duds and towards the masterpieces.
        </p>
        <h3 className="text-white">What We Do</h3>
        <p className="text-white mb-4">
          Our platform combines a massive title database with an authentic, community-driven
          review system powered by Google. Browse titles, watch full trailers, check IMDB scores,
          and most importantly—read real reviews from users just like you, or drop your own 5-star rating!
        </p>
        <h3 className="text-white"> Join Our Cinematic Community</h3>
        <p className="text-white mb-4">
          We’re excited to have you here and can’t wait to read your thoughts on your latest watch.
          Dive in, explore the reviews, log in, and let your cinematic voice be heard. 
          Thank you for visiting ReelReviews!
        </p>
        <a className="mb-5" href="/contact">
          For any questions or feedback, feel free to Contact Us.
        </a>
      </div>
      <hr style={{ color: "white" }}></hr>
      <Footer />
    </div>
  );
}

export default About;
